import {
  DashboardFilterPillPopoverContentProps,
  DashboardFilterPillsUIStateWithSetters,
  DatePopoverProps,
  HierarchicalListPopoverProps,
  ListPopoverProps,
  NumberPopoverProps,
} from '@ardoq/table-filter-bar';
import { Maybe } from '@ardoq/common-helpers';
import { type I18nLocale, t } from '@ardoq/i18n';

export const toValuePopoverContentProps = (
  content: DashboardFilterPillPopoverContentProps,
  {
    popoverInputValue,
    setPopoverInputValue,
    toggleIsValuePopoverOpen,
  }: DashboardFilterPillsUIStateWithSetters,
  i18nLocale: I18nLocale
):
  | ListPopoverProps
  | HierarchicalListPopoverProps
  | NumberPopoverProps
  | DatePopoverProps => {
  switch (content.type) {
    case 'number':
      return {
        ...content,
        allowDecimals: false,
        errorMessage:
          popoverInputValue !== null && !Number.isFinite(popoverInputValue)
            ? t(
                i18nLocale,
                'dashboard:filter.numberPopover.notNumeric',
                'This is not a numeric value'
              )
            : typeof popoverInputValue === 'number' &&
                popoverInputValue >= Number.MAX_SAFE_INTEGER
              ? t(
                  i18nLocale,
                  'dashboard:filter.numberPopover.tooLarge',
                  'Number is too large'
                )
              : undefined,
        value: Number(popoverInputValue),
        setValue: setPopoverInputValue,
        isDisabled:
          popoverInputValue === null ||
          typeof popoverInputValue !== 'number' ||
          !Number.isFinite(popoverInputValue) ||
          popoverInputValue >= Number.MAX_SAFE_INTEGER,
        onFormSubmit: () => {
          toggleIsValuePopoverOpen();
          if (
            popoverInputValue !== null &&
            typeof popoverInputValue === 'number' &&
            Number.isFinite(popoverInputValue) &&
            popoverInputValue < Number.MAX_SAFE_INTEGER
          ) {
            content.updateDashboardFilterValue(popoverInputValue);
          }
        },
      };
    case 'list':
      return content.filter
        ? {
            ...content,
            filter: {
              ...content.filter,
              value: String(popoverInputValue),
              onChange: (newValue: string) => {
                setPopoverInputValue(newValue);
                content.filter?.onChange(newValue);
              },
            },
          }
        : content;
    case 'hierarchicalList':
      return content.filter
        ? {
            ...content,
            filter: {
              ...content.filter,
              value: String(popoverInputValue),
              onChange: (newValue: string) => {
                setPopoverInputValue(newValue);
                content.filter?.onChange(newValue);
              },
            },
          }
        : content;
    case 'date':
      return {
        ...content,
        isDisabled: false,
        setValue: (value: Maybe<string>) => {
          toggleIsValuePopoverOpen();
          content.updateDashboardFilterValue(value);
        },
      };
    default:
      content satisfies never;
      throw new Error('Unsupported popover content type');
  }
};
